import { ROUTES } from "@/routes";
import { theme } from "@/theme";
import {
  CircularProgress,
  Stack,
  ThemeProvider,
  Typography,
} from "@mui/material";
import { useEffect } from "react";
import { useNavigate, useRouteError } from "react-router-dom";

const ErrorPage = () => {
  const navigate = useNavigate();
  const routeError = useRouteError();
  const isDev = import.meta.env.DEV;
  const routeErrorMessage = (() => {
    if (!routeError) return undefined;
    if (routeError instanceof Error) return routeError.message;
    try {
      return JSON.stringify(routeError);
    } catch {
      return String(routeError);
    }
  })();

  useEffect(() => {
    // Surface route-level exceptions that otherwise only show the generic fallback UI.
    // eslint-disable-next-line no-console
    console.error("Router error boundary:", routeError);
  }, [routeError]);

  useEffect(() => {
    if (isDev) return;
    const timeoutId = setTimeout(() => {
      navigate(ROUTES.HOME);
    }, 2500);

    return () => clearTimeout(timeoutId);
  }, [isDev, navigate]);

  return (
    <ThemeProvider theme={theme}>
      <Stack
        direction={"column"}
        gap={2}
        sx={{
          justifyContent: "center",
          alignItems: "center",
          height: "75vh",
          textAlign: "center",
        }}
      >
        <CircularProgress />
        <Typography variant="h3">
          Zdá se že tato stránka neexistuje nebo došlo k chybě.
        </Typography>
        <Typography variant="h4">Přesměrujeme Vás.</Typography>
        {isDev && routeErrorMessage && (
          <Typography sx={{ maxWidth: 900, px: 2, whiteSpace: "pre-wrap", wordBreak: "break-word" }}>
            {routeErrorMessage}
          </Typography>
        )}
      </Stack>
    </ThemeProvider>
  );
};

export default ErrorPage;
